export default "__VITE_ASSET__BbVohza7__"